module.exports = __webpack_public_path__ + "img/t2.66114ec1.png";